var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "arrow-down.bf64b264.png","uri@2x": __webpack_public_path__ + "arrow-down.3ea946a6.png","uri@3x": __webpack_public_path__ + "arrow-down.3380ed1a.png",
    width: 20,
    height: 12
});